/**
 * @function handleClick
 * @description Handles the click Event
 * @param {Object} data module config object
 * @param {Object} element
 * @param {Number} i duration of the click event
 */
export default function handleClick(data, element, i, duration) {
    const module = data.config.module;

    if (data.state.disabled) return;

    // trigger the event only once for the same element
    const card = document.querySelector(`[data-emi-${module}-scene="${i}"]`);
    if (card.classList.contains(`${module}-scene--reveal`)) return;
    card.classList.add(`${module}-scene--reveal`);

    if (data.config.pile)
        card.style.transform = `translateY(0px) translateX(calc(60% * ${data.state.selected.length}))`;
    if (data.config.pile) card.style.zIndex = `${data.state.selected.length}`;

    if (data.config.rotation)
        document.querySelector(`[data-emi-${module}-back`).style.transform = `rotate(${data.config.rotation})`;

    data.state.selected.push(i);

    // disable the event until animation ends
    data.stop();
    console.log('animation start');
    setTimeout(function () {
        data.start();
        if (data.state.selected.length === data.config.amount) {
            data.stop();
            document.querySelector(`[data-emi-${module}-table]`).classList.add('status--disabled');
            document.getElementById(`app-emi-${module}`).classList.add('status--disabled');
        }
        Maestro.getInstance().EventBus.emit(`${module}-card-selected`, data.result());
        console.log('animation end');
    }, duration);
}
